<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less" scoped>
@import '~@/assets/css/style/index.less';
html{
 
}

</style>


// WEBPACK FOOTER //
// src/App.vue